import React from "react";
import { Copy, Download, PackageSearch, RefreshCcw, Save, Users } from "lucide-react";

export default function CalculatieActionBar({
  editingId,
  saving,
  copying,
  duplicating,
  onCopy,
  onDuplicateSameClient,
  onToggleDuplicate,
  onToggleRefreshPricing,
  onOpenPdf,
  onOpenCatalog,
}) {
  return (
    <div className="flex flex-wrap items-center justify-end gap-2">
      {editingId ? (
        <button
          type="button"
          onClick={onCopy}
          disabled={copying || duplicating}
          className="inline-flex items-center gap-2 rounded-md border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50 disabled:opacity-60"
        >
          <Copy size={16} />
          {copying ? "Maakt revisie..." : "Nieuwe revisie"}
        </button>
      ) : null}

      {editingId ? (
        <button
          type="button"
          onClick={onDuplicateSameClient}
          disabled={copying || duplicating}
          className="inline-flex items-center gap-2 rounded-md border border-sky-300 bg-sky-50 px-3 py-2 text-sm font-medium text-sky-800 transition hover:bg-sky-100 disabled:opacity-60"
        >
          <Users size={16} />
          Dupliceer zelfde klant
        </button>
      ) : null}

      {editingId ? (
        <button
          type="button"
          onClick={onToggleDuplicate}
          disabled={copying || duplicating}
          className="inline-flex items-center gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm font-medium text-amber-800 transition hover:bg-amber-100 disabled:opacity-60"
        >
          <Users size={16} />
          Kopie naar andere klant
        </button>
      ) : null}

      {editingId ? (
        <button
          type="button"
          onClick={onToggleRefreshPricing}
          disabled={copying || duplicating}
          className="inline-flex items-center gap-2 rounded-md border border-violet-300 bg-violet-50 px-3 py-2 text-sm font-medium text-violet-800 transition hover:bg-violet-100 disabled:opacity-60"
        >
          <RefreshCcw size={16} />
          Prijzen actualiseren
        </button>
      ) : null}

      {editingId ? (
        <button
          type="button"
          onClick={onOpenPdf}
          className="inline-flex items-center gap-2 rounded-md border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50"
        >
          <Download size={16} />
          PDF
        </button>
      ) : null}

      {editingId ? (
        <button
          type="button"
          onClick={onOpenCatalog}
          className="inline-flex items-center gap-2 rounded-md border border-emerald-300 bg-emerald-50 px-3 py-2 text-sm font-medium text-emerald-700 transition hover:bg-emerald-100"
        >
          <PackageSearch size={16} />
          OCI / catalogus
        </button>
      ) : null}

      <button
        type="submit"
        disabled={saving || copying || duplicating}
        className="inline-flex items-center gap-2 rounded-md bg-slate-900 px-4 py-2 text-sm font-semibold text-white transition hover:bg-slate-800 disabled:opacity-60"
      >
        <Save size={16} />
        {saving ? "Opslaan..." : "Opslaan"}
      </button>
    </div>
  );
}
